import bmAxiosClient from "../../GenAPI/axiosClient";

const post = (data) => bmAxiosClient.post('/api/bmErrorLogger/log', data);

export default {post};